/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Notopics1Inputs */

const id_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada topik yang dilanggani`)
};

const ms_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada topik dilanggan`)
};

const da_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen emner abonneret`)
};

const de_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Themen abonniert`)
};

const en_us2_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No topics subscribed`)
};

const es_es2_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay temas suscritos`)
};

const es_mx2_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay temas suscritos`)
};

const fil_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang naka-subscribe na paksa`)
};

const fr_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun sujet abonné`)
};

const it_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun argomento sottoscritto`)
};

const hu_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs feliratkozott téma`)
};

const nl_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen onderwerpen geabonneerd`)
};

const no_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen emner abonnert`)
};

const pl_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak subskrybowanych tematów`)
};

const pt_br2_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum tópico inscrito`)
};

const pt_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum tópico subscrito`)
};

const ro_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niciun subiect abonat`)
};

const fi_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tilattuja aiheita`)
};

const sv_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga prenumererade ämnen`)
};

const vi_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có chủ đề nào đã đăng ký`)
};

const tr_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone olunan konu yok`)
};

const cs_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná odebíraná témata`)
};

const bg_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма абонирани теми`)
};

const ru_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет подписанных тем`)
};

const uk_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає підписаних тем`)
};

const ar_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد موضوعات مشترك فيها`)
};

const hi_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई विषय सब्सक्राइब नहीं`)
};

const th_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีหัวข้อที่สมัครรับ`)
};

const ja_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読中のトピックはありません`)
};

const zh_cn2_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无订阅主题`)
};

const zh_hant1_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無訂閱主題`)
};

const ko_notifications_notopics1 = /** @type {(inputs: Notifications_Notopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독한 주제 없음`)
};

/**
* | output |
* | --- |
* | "No topics subscribed" |
*
* @param {Notifications_Notopics1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_notopics1 = /** @type {((inputs?: Notifications_Notopics1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Notopics1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_notopics1(inputs)
	if (locale === "ms") return ms_notifications_notopics1(inputs)
	if (locale === "da") return da_notifications_notopics1(inputs)
	if (locale === "de") return de_notifications_notopics1(inputs)
	if (locale === "en-US") return en_us2_notifications_notopics1(inputs)
	if (locale === "es-ES") return es_es2_notifications_notopics1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_notopics1(inputs)
	if (locale === "fil") return fil_notifications_notopics1(inputs)
	if (locale === "fr") return fr_notifications_notopics1(inputs)
	if (locale === "it") return it_notifications_notopics1(inputs)
	if (locale === "hu") return hu_notifications_notopics1(inputs)
	if (locale === "nl") return nl_notifications_notopics1(inputs)
	if (locale === "no") return no_notifications_notopics1(inputs)
	if (locale === "pl") return pl_notifications_notopics1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_notopics1(inputs)
	if (locale === "pt") return pt_notifications_notopics1(inputs)
	if (locale === "ro") return ro_notifications_notopics1(inputs)
	if (locale === "fi") return fi_notifications_notopics1(inputs)
	if (locale === "sv") return sv_notifications_notopics1(inputs)
	if (locale === "vi") return vi_notifications_notopics1(inputs)
	if (locale === "tr") return tr_notifications_notopics1(inputs)
	if (locale === "cs") return cs_notifications_notopics1(inputs)
	if (locale === "bg") return bg_notifications_notopics1(inputs)
	if (locale === "ru") return ru_notifications_notopics1(inputs)
	if (locale === "uk") return uk_notifications_notopics1(inputs)
	if (locale === "ar") return ar_notifications_notopics1(inputs)
	if (locale === "hi") return hi_notifications_notopics1(inputs)
	if (locale === "th") return th_notifications_notopics1(inputs)
	if (locale === "ja") return ja_notifications_notopics1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_notopics1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_notopics1(inputs)
	return ko_notifications_notopics1(inputs)
});
export { notifications_notopics1 as "notifications.noTopics" }